import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material/styles';

import routes from 'constants/routes';
import { CookieService } from 'features/auth/services/CookieService';

import QuotationsNew from 'pages/Quotations/new';
import QuotationsList from 'pages/Quotations/list';
import QuotationEdit from 'pages/Quotations/edit';

import Login from 'pages/Login';
import ClientNotLogingAllow from 'pages/ClientNotLoging/indx';

import AgencyNew from 'pages/Agency/new';
import AgencyUpdate from 'pages/Agency/update';

import { QuotaDataReport } from 'pages/QuotaData/index';
import { SalesOrderListPage } from 'pages/SalesOrder/salesOrderList';
import { SalesOrderCalendarPage } from 'pages/SalesOrder/salesOrderCalendar';
import { CashPaymentPage } from 'pages/Payment/CashPayment';
import UserList from 'pages/User/list';
import UserNew from 'pages/User/new';
import ClientPreview from './pages/Quotations/clientPreview';
import makeStyles from '@mui/styles/makeStyles';
import packageJson from '../package.json';
import ClientPaymentOrder from 'pages/Payment/ClientPaymentOrder';
import TransactionList from 'pages/Transactions/list';
import PackageStats from 'pages/Stats/Packages';
import TransactionDetails from 'pages/Transactions/details';
import AuthorizationDetails from 'pages/Authorization/details';
import AuthorizationList from 'pages/Authorization/list';
import CrossList from 'pages/Cross/list';
import GatewayTransactionList from 'pages/Transactions/gatewayList';
import { BancardCheckConfirmation } from './pages/Payment/CheckBancardPaymentOrder';
import { ThankYouTransaction } from './pages/Payment/ThankYouTransaction';
import Rates from './pages/Stats/Rates';
import ReservationSearch from './pages/Reservation/search';
import HotelSearch from './pages/Hotel/search';
import HotelFareCard from './pages/Hotel/fareCard';
import { WireTransferCheck } from './pages/Payment/WireTransferCheck';
import QuotationDefaultDescriptionConfig from './pages/Quotations/defaultDescriptionConfig';
import { DefaultNotIncludes } from './pages/Quotations/defaultNotIncludes';
import { DataStudioSellerReport } from './pages/DataStudio/SellerReport';
import AutomaticRouteStats from './pages/Stats/AutomaticRoutes';
import { PackageExplorer } from './pages/PackageExplorer/mainPage';
import { PackageExplorerDestinationDetailPage } from './pages/PackageExplorer/destinationDetail';
import { FightExplorer } from './pages/FlightExplorer/mainPage';
import { AtcCheckConfirmation } from './features/payment/components/AtcCheckConfirmation';
import { CancelTransaction } from './pages/Payment/CancelTransaction';
import { FlightExplorerDestinationDetailPage } from './pages/FlightExplorer/destinationDetail';
import { CashTransactionPage } from './pages/Transactions/CashTransactionPage';
import { OrderPage } from './pages/Payment/OrderPage';
import { OrderPageViajeNaranja } from 'pages/Payment/OrderPageViajeNaranja';
import { SalesOrderCreatePage } from './pages/SalesOrder/saleOrderCreate';
import { QuotationImportPage } from './pages/SalesOrder/quotationImport';
import QuotationsNewOnlyFlights from './pages/Quotations/newOnlyFlights';
import QuotationsEditOnlyFlight from './pages/Quotations/editOnlyFlights';
import ViajeNaranjaBancardTransactionList from './pages/Transactions/bancardListOrangeAgency';
import VNItauPointTransactionList from 'pages/Transactions/VNItauPointTransactionList';
import SaleReportPage from './pages/Quotations/SaleReport';
import { mevuelo } from './assets/themes';
// import { SalesOrderView } from './pages/SalesOrder/saleOrderView';
import { ActivityLogListPage } from './pages/ActivityLog/List';
import { WompiCheckConfirmation } from 'pages/Payment/CheckWompiPaymentOrder';
import { ProvidersList } from 'pages/Providers/list';
import { ProviderDetailPage } from 'pages/Providers/details';
import { CustomersList } from 'pages/Customers/list';
import { SalesOrderScreen } from 'pages/SalesOrder/SalesOrderScreen';
import { FlightIssueRuleUpsertPage } from './pages/FlightIssueRule/FlightIssueRuleUpsertPage';
import { FlightIssueRuleListPage } from './pages/FlightIssueRule/FlightIssueRuleListPage';
import { CostIssuingRulesListPage } from './pages/CostIssuingRules/CostIssuingRulesListPage';
import { CustomersSyncProcessStatusPage } from './pages/SalesOrder/customersSyncProcessStatusPage';
import Home from './pages/Home/index';
import Refund from './pages/Refund/index';
import AirlineMerchantReferencePage from 'pages/Airlines/AirlineMerchantReferencePage';
import PrechargedServicesPage from 'pages/PrechargedServices';
import PrechargedServiceDetailPage from 'pages/PrechargedServices/detail';
import { DLocalCheckConfirmation } from './pages/Payment/CheckDLocalPaymentOrder';
import { PassengersListPage } from './pages/Passengers/list';
import { CreditRulesRoute } from './pages/CreditRules';
import { ReceivablesRoute } from './pages/Receivables';
import { PassengerDetailPage } from './pages/Passengers/details';
import { PassengerAccountStatementPage } from './pages/Passengers/accountStatement';
import { FlightAndAncillaryETicketSummaryListPage } from './pages/Operations/FlightAndAncillaryETicketSummaryListPage';
import { FlightIssuingControlListPage } from './pages/Operations/FlightIssuingControlListPage';
import CurrencyRatesAdminPage from './pages/Stats/CurrencyRatesAdminPage';
import BranchOfficeListPage from './pages/BranchOffice/list';
import BranchOfficeDetailPage from './pages/BranchOffice/detail';
import { SellersTeamGoalPage } from './pages/Sellers/SellersTeamGoalPage';
import { McpConnectorUsersPage } from './pages/McpConnector/McpConnectorUsersPage';
import { SalesOrderFromExternalRedirectPage } from './pages/SalesOrder/salesOrderFromExternalRedirectPage';
import { InvoiceDetailPage } from './pages/SalesOrder/Invoice';
import { SalesOrderBillingSyncProcessStatusPage } from './pages/SalesOrder/salesOrderBillingSyncProcessStatusPage';
import { SalesOrderResumeByPaxPage } from './pages/SalesOrder/salesOrderResumeByPax';
import { SaleOrderServicesListPage } from './pages/SalesOrder/saleOrderServicesListPage';
import EmailSignatureSimple from './pages/Tools/EmailSignature';
import SalesToolsPage from './pages/SalesTools';
import { ProviderPaymentCalendarPage } from './pages/Providers/paymentCalendarPage';
import { ProviderPaymentsListPage } from './pages/ProviderPayments/list';
import { ProviderPaymentsBulkPage } from './pages/ProviderPayments/bulk';
import { ProviderPaymentsPaymentsPage } from './pages/ProviderPayments/payments';
import { ProviderPaymentsSchedulePage } from './pages/ProviderPayments/schedule';
import { ClientPaymentsListPage } from './pages/ClientPayments/list';
import { InvoicesListPage } from './pages/Invoices/list';
import TransactionDetailsUnified from './pages/TransactionDetails';
import TransactionLookupPage from './pages/TransactionLookup';
import { CrmWorkflowsAdmin } from './pages/Dashboard/CrmWorkflowsAdmin';
import { SellerDashboardRoute, TeamDashboardRoute } from './pages/Dashboard/SalesDashboard';
import {
	BranchCashRoute,
	CashOverviewRoute,
	DepositWizardRoute,
	DepositActDetailRoute,
	DepositActsListRoute,
	CashTargetsRoute,
	OldTeamCashRedirect,
} from './pages/Dashboard/BranchCash';
import { DashboardErrorBoundary } from './features/salesDashboard/components/DashboardErrorBoundary';
const TransactionListV2Page = lazy(() => import('pages/Transactions/list-v2'));
const ProductSectionPage = lazy(() => import('./pages/Product'));
const ProductAnalyticsPage = lazy(() => import('./pages/ProductAnalytics'));
const AirRoutesPage = lazy(() => import('./pages/AirRoutes'));
const AuthorizationListV2Page = lazy(() => import('pages/Authorization/list-v2'));
const CrossesListV2Page = lazy(() => import('pages/Transactions/crosses-v2'));
const WalletAddCardPage = lazy(() => import('./pages/WalletAddCard'));
const CardDeskPage = lazy(() => import('./pages/CardDesk'));
const CardDeskChargeClientPage = lazy(() => import('./pages/CardDesk/ChargeClient'));
const CorporateCardsPage = lazy(() => import('./pages/CorporateCards'));

const LazyRouteFallback = (): JSX.Element => (
	<Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
		<CircularProgress />
	</Box>
);

export const APP_VERSION = packageJson.version;

declare module '@mui/styles/defaultTheme' {
	// eslint-disable-next-line @typescript-eslint/no-empty-interface
	interface DefaultTheme extends Theme {}
}

const useStyles = makeStyles(() => ({
	version: {
		color: '#31194B',
		fontSize: '12px',
		fontWeight: 'bold',
		position: 'fixed',
		bottom: '0.5rem',
		right: '0.5rem',
		padding: '0 0.5rem',
		borderRadius: '6px',
		cursor: 'pointer',
		transition: 'all 0.3s',
		zIndex: '200',
		backgroundColor: 'white',
	},
}));

function App(): JSX.Element {
	const token = CookieService.getToken();
	const classes = useStyles();

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={mevuelo}>
				<Router forceRefresh={true}>
					{token ? (
						<Switch>
							<Route exact path={routes.auth.login}>
								<Redirect to={routes.home} />
							</Route>
							<Route exact path={routes.refund}>
								<Refund />
							</Route>
							<Route exact path={routes.airlines.merchantAndInstallments}>
								<AirlineMerchantReferencePage />
							</Route>
							<Route exact path={routes.airlines.merchantAndInstallmentsByCarrier}>
								<AirlineMerchantReferencePage />
							</Route>
							<Route exact path={routes.operations.flightAndAncillaryTickets}>
								<FlightAndAncillaryETicketSummaryListPage />
							</Route>
							<Route exact path={routes.operations.flightIssuingControl}>
								<FlightIssuingControlListPage />
							</Route>
							<Route exact path={routes.operations.walletAddCard}>
								<Suspense fallback={<LazyRouteFallback />}>
									<WalletAddCardPage />
								</Suspense>
							</Route>
							<Route exact path={[routes.operations.cardDesk, routes.operations.cardDeskRules]}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CardDeskPage />
								</Suspense>
							</Route>
							<Route exact path={routes.operations.cardDeskBoard}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CardDeskPage />
								</Suspense>
							</Route>
							<Route exact path={routes.operations.cardDeskCharges}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CardDeskPage />
								</Suspense>
							</Route>
							<Route exact path={routes.prechargedServices}>
								<PrechargedServicesPage />
							</Route>
							<Route exact path={routes.prechargedServiceDetail}>
								<PrechargedServiceDetailPage />
							</Route>
							<Route exact path={routes.quotations.new}>
								<QuotationsNew />
							</Route>
							<Route exact path={routes.quotations.newOnlyFlights}>
								<QuotationsNewOnlyFlights />
							</Route>
							<Route exact path={routes.quotations.edit}>
								<QuotationEdit />
							</Route>
							<Route exact path={routes.quotations.editOnlyFlights}>
								<QuotationsEditOnlyFlight />
							</Route>
							<Route exact path={routes.quotations.list}>
								<QuotationsList />
							</Route>
							<Route exact path={routes.quotations.saleReport}>
								<SaleReportPage />
							</Route>
							<Route exact path={routes.salesOrder.new}>
								<SalesOrderCreatePage />
							</Route>
							<Route exact path={routes.salesOrder.newFromQuotation}>
								<QuotationImportPage />
							</Route>
							<Route exact path={routes.salesOrder.list}>
								<SalesOrderListPage />
							</Route>
							<Route exact path={routes.salesOrder.calendar}>
								<SalesOrderCalendarPage />
							</Route>
							{/* <Route exact path={routes.salesOrder.edit}>
								<SalesOrderView />
							</Route> */}
							<Route exact path={routes.salesOrder.importFromQuotation}>
								<QuotationImportPage />
							</Route>
							<Route exact path={routes.salesOrder.edit}>
								<SalesOrderScreen />
							</Route>
							<Route exact path={routes.salesOrder.saleOrderInvoiceDetail}>
								<InvoiceDetailPage />
							</Route>
							<Route exact path={routes.salesOrder.resumeByPax}>
								<SalesOrderResumeByPaxPage />
							</Route>
							<Route exact path={routes.salesOrder.fromNetsuiteId}>
								<SalesOrderFromExternalRedirectPage />
							</Route>
							<Route exact path={routes.salesOrder.serviceList}>
								<SaleOrderServicesListPage />
							</Route>
							<Route exact path={routes.hotels.search}>
								<HotelSearch />
							</Route>
							<Route exact path={routes.providers.list}>
								<ProvidersList />
							</Route>
							<Route exact path={routes.providers.detail}>
								<ProviderDetailPage />
							</Route>
							<Route path={routes.providers.paymentCalendar}>
								<ProviderPaymentCalendarPage />
							</Route>
							<Route exact path={routes.providerPayments.list}>
								<ProviderPaymentsListPage />
							</Route>
							<Route exact path={routes.providerPayments.bulk}>
								<ProviderPaymentsBulkPage />
							</Route>
							<Route exact path={routes.providerPayments.payments}>
								<ProviderPaymentsPaymentsPage />
							</Route>
							<Route exact path={routes.providerPayments.schedule}>
								<ProviderPaymentsSchedulePage />
							</Route>
							<Route exact path={routes.clientPayments.list}>
								<ClientPaymentsListPage />
							</Route>
							<Route exact path={routes.invoices.list}>
								<InvoicesListPage />
							</Route>
							<Route path={routes.customers.list}>
								<CustomersList />
							</Route>
							<Route path={routes.agency.new}>
								<AgencyNew />
							</Route>
							<Route path={routes.agency.update}>
								<AgencyUpdate />
							</Route>
							<Route path={routes.payment.order}>
								<OrderPage />
							</Route>
							<Route path={routes.payment.orderNaranja}>
								<OrderPageViajeNaranja />
							</Route>
							<Route path={routes.payment.wireTransferCheck}>
								<WireTransferCheck />
							</Route>
							<Route path={routes.payment.orderCash}>
								<CashPaymentPage />
							</Route>
							<Route path={routes.transactions.cashTransactions}>
								<CashTransactionPage />
							</Route>
							<Route exact path={routes.packageExplorer.list}>
								<PackageExplorer />
							</Route>
							<Route path={routes.packageExplorer.destinationDetail}>
								<PackageExplorerDestinationDetailPage />
							</Route>
							<Route exact path={routes.flightExplorer.list}>
								<FightExplorer />
							</Route>
							<Route exact path={routes.flightExplorer.destinationDetail}>
								<FlightExplorerDestinationDetailPage />
							</Route>
							<Route path={routes.user.list}>
								<UserList />
							</Route>
							<Route path={routes.user.new}>
								<UserNew />
							</Route>
							<Route exact path={routes.transactions.list}>
								<TransactionList />
							</Route>
							<Route exact path={routes.transactions.listV2}>
								<Suspense fallback={<LazyRouteFallback />}>
									<TransactionListV2Page />
								</Suspense>
							</Route>
							<Route exact path={routes.transactions.gatewayTransactionList}>
								<GatewayTransactionList />
							</Route>
							<Route exact path={routes.transactions.viajeNaranjaBancardTransactionList}>
								<ViajeNaranjaBancardTransactionList />
							</Route>
							<Route exact path={routes.transactions.viajeNaranjaItauPointTransactionList}>
								<VNItauPointTransactionList />
							</Route>
							<Route path={routes.stats.package}>
								<PackageStats />
							</Route>
							<Route path={routes.stats.automaticRoute}>
								<AutomaticRouteStats />
							</Route>
							<Route path={routes.transactions.details}>
								<TransactionDetails />
							</Route>
							<Route exact path={routes.transactions.detailsUnified}>
								<DashboardErrorBoundary>
									<TransactionDetailsUnified />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.transactions.lookup}>
								<TransactionLookupPage />
							</Route>
							<Route exact path={routes.authorizations.list}>
								<AuthorizationList />
							</Route>
							<Route exact path={routes.authorizations.listV2}>
								<Suspense fallback={<LazyRouteFallback />}>
									<AuthorizationListV2Page />
								</Suspense>
							</Route>
							<Route exact path={routes.crosses.list}>
								<CrossList />
							</Route>
							<Route exact path={routes.crosses.listV2}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CrossesListV2Page />
								</Suspense>
							</Route>
							<Route path={routes.authorizations.details}>
								<AuthorizationDetails />
							</Route>
							<Route path={routes.stats.ratesList}>
								<Rates />
							</Route>
							<Route path={routes.stats.ratesAdmin}>
								<CurrencyRatesAdminPage />
							</Route>
							<Route exact path={routes.hotels.fareCard}>
								<HotelFareCard />
							</Route>
							<Route path={routes.hotels.searchReservations}>
								<ReservationSearch />
							</Route>
							<Route exact path={routes.quotations.description}>
								<QuotationDefaultDescriptionConfig />
							</Route>
							<Route exact path={routes.quotations.defaultNotIncludes}>
								<DefaultNotIncludes />
							</Route>
							<Route exact path={routes.dataStudio}>
								<DataStudioSellerReport />
							</Route>
							<Route exact path={routes.quotaData}>
								<QuotaDataReport />
							</Route>
							<Route exact path={routes.activityLogList}>
								<ActivityLogListPage />
							</Route>
							<Route exact path={routes.flightIssueRule.list}>
								<FlightIssueRuleListPage />
							</Route>
							<Route exact path={routes.flightIssueRule.upsert}>
								<FlightIssueRuleUpsertPage />
							</Route>
							<Route exact path={routes.costIssuingRules.list}>
								<CostIssuingRulesListPage />
							</Route>
							<Route exact path={routes.salesOrder.customersSyncStatus}>
								<CustomersSyncProcessStatusPage />
							</Route>
							<Route exact path={routes.salesOrder.salesOrderBillingStatusSyncStatus}>
								<SalesOrderBillingSyncProcessStatusPage />
							</Route>
							{/* Antes de las rutas con params para que no matchee /passengers/:id. */}
							<Route exact path={routes.creditRules.root}>
								<CreditRulesRoute />
							</Route>
							<Route exact path={routes.receivables.cartera}>
								<ReceivablesRoute />
							</Route>
							<Route exact path={routes.passengers.list}>
								<PassengersListPage />
							</Route>
							<Route exact path={routes.passengers.detail}>
								<PassengerDetailPage />
							</Route>
							<Route exact path={routes.passengers.accountStatement}>
								<PassengerAccountStatementPage />
							</Route>

							<Route exact path={routes.branchOffices.list}>
								<BranchOfficeListPage />
							</Route>
							<Route exact path={routes.branchOffices.detail}>
								<BranchOfficeDetailPage />
							</Route>
							<Route exact path={routes.sellers.teamsAndGoals}>
								<SellersTeamGoalPage />
							</Route>
							<Route exact path={routes.mcpConnector.users}>
								<McpConnectorUsersPage />
							</Route>
							<Route exact path={routes.tools.emailSignature}>
								<EmailSignatureSimple />
							</Route>
							<Route path={routes.salesTools.root}>
								<SalesToolsPage />
							</Route>
							{/*<Route exact path={'/test'}>*/}
							{/*	<FlightItineraryCard />*/}
							{/*</Route>*/}
							{/* ── Producto (Paquetes — Support API) ──────────── */}
							{/* Un solo route para toda la sección: la navegación interna
							    entre vistas usa pushState (sin hard refresh). */}
							<Route
								exact
								path={[
									routes.product.pulse,
									routes.product.explorer,
									routes.product.packageDetail,
									routes.product.destinations,
									routes.product.priceWatch,
									routes.product.admin,
								]}
							>
								<Suspense fallback={<LazyRouteFallback />}>
									<ProductSectionPage />
								</Suspense>
							</Route>
							{/* ── Análisis de Producto (solo Admin/SuperAdmin) ── */}
							<Route
								exact
								path={[
									routes.productAnalytics.root,
									routes.productAnalytics.seasonality,
									routes.productAnalytics.destinations,
									routes.productAnalytics.mix,
									routes.productAnalytics.airlines,
									routes.productAnalytics.accommodations,
									routes.productAnalytics.passengers,
									routes.productAnalytics.pricing,
									routes.productAnalytics.cancellations,
									routes.productAnalytics.admin,
								]}
							>
								<Suspense fallback={<LazyRouteFallback />}>
									<ProductAnalyticsPage />
								</Suspense>
							</Route>
							{/* ── Rutas Aéreas ────────────────────────────────── */}
							<Route exact path={routes.airRoutes.root}>
								<Suspense fallback={<LazyRouteFallback />}>
									<AirRoutesPage />
								</Suspense>
							</Route>
							{/* ── Tarjetas Corporativas ────────────────────────── */}
							<Route exact path={routes.corporateCards.root}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CorporateCardsPage />
								</Suspense>
							</Route>
							{/* ── Cajas de sucursal ───────────────────────────── */}
							{/* IMPORTANTE: rutas fijas y más específicas ANTES que los patrones */}
							<Route exact path={routes.branchCash.overview}>
								<DashboardErrorBoundary>
									<CashOverviewRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.branchCash.deposits}>
								<DashboardErrorBoundary>
									<DepositActsListRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.branchCash.targets}>
								<DashboardErrorBoundary>
									<CashTargetsRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.branchCash.depositDetailPattern}>
								<DashboardErrorBoundary>
									<DepositActDetailRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.branchCash.depositPattern}>
								<DashboardErrorBoundary>
									<DepositWizardRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.branchCash.detailPattern}>
								<DashboardErrorBoundary>
									<BranchCashRoute />
								</DashboardErrorBoundary>
							</Route>
							{/* Redirects de rutas viejas → nuevas */}
							<Route exact path="/cajas/hq">
								<Redirect to={routes.branchCash.detail('caja-hq')} />
							</Route>
							<Route exact path="/dashboard/equipo/:teamSlug/caja">
								<OldTeamCashRedirect />
							</Route>
							{/* ── Sales Dashboard (rutas nuevas) ─────────────── */}
							{/* IMPORTANTE: la ruta de equipo debe ir ANTES que la de vendedor */}
							<Route exact path={routes.salesDashboard.teamPattern}>
								<DashboardErrorBoundary>
									<TeamDashboardRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.salesDashboard.sellerPattern}>
								<DashboardErrorBoundary>
									<SellerDashboardRoute />
								</DashboardErrorBoundary>
							</Route>
							<Route exact path={routes.salesDashboard.admin}>
								<DashboardErrorBoundary>
									<CrmWorkflowsAdmin />
								</DashboardErrorBoundary>
							</Route>
							{/* DEFAULT */}
							<Route path={routes.home}>
								<Home />
							</Route>
							{/* <Route path={routes.home}>
								{!auth.user?.dataStudioUrl && <Redirect to={routes.quotations.list} />}
								{auth.user?.dataStudioUrl && <Redirect to={routes.dataStudio} />}
							</Route> */}
						</Switch>
					) : (
						<Switch>
							<Route path={routes.auth.login}>
								{window.location.hostname === 'tuviaje.mevuelo.com' ? (
									<Redirect to={routes.clientNotLogin} />
								) : (
									<Login />
								)}
							</Route>
							<Route path={routes.clientNotLogin}>
								<ClientNotLogingAllow />
							</Route>

							<Route exact path={routes.quotations.previewClient}>
								<ClientPreview />
							</Route>

							<Route exact path={routes.payment.clientTransaction}>
								<ClientPaymentOrder />
							</Route>
							<Route exact path={routes.payment.chargeClient}>
								<Suspense fallback={<LazyRouteFallback />}>
									<CardDeskChargeClientPage />
								</Suspense>
							</Route>
							<Route exact path={routes.payment.bancardCheckConfirmation}>
								<BancardCheckConfirmation />
							</Route>
							<Route exact path={routes.payment.dLocalCheckConfirmation}>
								<DLocalCheckConfirmation />
							</Route>
							<Route exact path={routes.payment.wompiCheckConfirmation}>
								<WompiCheckConfirmation />
							</Route>
							<Route path={routes.payment.atcCheckConfirmation}>
								<AtcCheckConfirmation />
							</Route>
							<Route exact path={routes.payment.thankYouTransaction}>
								<ThankYouTransaction />
							</Route>
							<Route exact path={routes.payment.cancelTransaction}>
								<CancelTransaction />
							</Route>
							<Route path={routes.home}>
								<Redirect to={routes.auth.login} />
							</Route>
						</Switch>
					)}
					<div className={classes.version}>{APP_VERSION}</div>
				</Router>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default App;
